import Client from "./Client";
// import RequestList from "./RequestList";

const FaxesService = {
    url: 'admin/receipts',
    getDefault(){
        return {
            id: undefined,
            subscription_class_id: undefined,
            user_id: undefined,
            sub_total: undefined,
            tax_due: undefined,
            total_due: undefined,
            status: undefined,
            description: undefined,
            reference_code: undefined,
            gateway_params: undefined,
            callback_url: undefined,
            redirect_url: undefined,
            created_at: undefined,
            updated_at: undefined,
            paid_at: undefined
        }
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async list(requestList) {
        return await Client.get(`${this.url}`, requestList.json());
    },

    /**
     * @params time_dimension
     * @params [] filters
     * @return Request Promise
     **/
    async getOverviewReport(time_dimension, filters) {
        return await Client.get(`${this.url}/reports/overview`, {
            time_dimension,
            filters
        });
    }
}

export default FaxesService